/* Load the slider library only when a slider is present, including AJAX/editor sections. */
(() => {
  const source = document.currentScript.dataset.swiperSrc;
  const pending = new Map();
  let request;
  let observer;
  let queued = false;
  let visibilityObserver;
  const observed = new WeakSet();

  const load = () => {
    if (window.Swiper) return Promise.resolve();
    if (request) return request;
    request = new Promise((resolve, reject) => {
      const script = document.createElement('script');
      script.src = source;
      script.onload = resolve;
      script.onerror = () => {
        script.remove();
        request = null;
        reject(new Error('Slider library could not be loaded'));
      };
      document.head.append(script);
    });
    return request;
  };

  const scan = () => {
    queued = false;
    const needed = [...pending.keys()].some(tag => [...document.querySelectorAll(tag)].some(element => {
      if (element.hasAttribute('data-nova-native-hero')) return false;
      const bounds = element.getBoundingClientRect();
      if (!('IntersectionObserver' in window)) return true;
      if (bounds.top < innerHeight + 100 && bounds.bottom > -100) return true;
      if ('IntersectionObserver' in window && !observed.has(element)) {
        visibilityObserver ||= new IntersectionObserver(entries => {
          if (entries.some(entry => entry.isIntersecting)) schedule();
        }, { rootMargin: '100px 0px' });
        visibilityObserver.observe(element);
        observed.add(element);
      }
      return false;
    }));
    if (!needed && !document.querySelector('#swiper-sidebar-carousel')) return;
    load().then(() => {
      pending.forEach((definition, tag) => {
        if (!customElements.get(tag)) customElements.define(tag, definition);
      });
      pending.clear();
      observer?.disconnect();
      visibilityObserver?.disconnect();
    }).catch(() => {}); // A later section insertion or interaction can retry.
  };
  const schedule = () => {
    if (queued) return;
    queued = true;
    queueMicrotask(scan);
  };

  window.novaRegisterSwiper = (tag, definition) => {
    if (window.Swiper) {
      if (!customElements.get(tag)) customElements.define(tag, definition);
      return;
    }
    pending.set(tag, definition);
    schedule();
  };
  window.novaLoadSwiper = load;
  observer = new MutationObserver(schedule);
  observer.observe(document.body, { childList: true, subtree: true });
  document.addEventListener('shopify:section:load', schedule);
  document.addEventListener('pointerdown', schedule, { passive: true });
  document.addEventListener('keydown', schedule);
})();
